import {
  Box,
  Container,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { appLogo } from "../../../../assets";
import AppLoader from "../../../../components/AppLoader";
import LanguageMenu from "../../../../components/LanguageMenu";
import { useNavigate, useParams } from "react-router-dom";
import AppContainer from "../../../../components/AppContainer";
import GlobalButton from "../../../../components/CustomButton";
import moment from "moment";
import { handleOpenSnackBar } from "../../../../utils";
import CustomSwitch from "../../../../components/CustomSwitch";
import { updateWorkerAvailability } from "../../../../services/worker/authenticationApiFn";
import appcolors from "../../../../constants/Colors";

const scheduleData = [
  {
    day: "Monday",
    isAvailable: false,
    startTime: "",
    endTime: "",
  },
  {
    day: "Tuesday",
    isAvailable: false,
    startTime: "",
    endTime: "",
  },
  {
    day: "Wednesday",
    isAvailable: false,
    startTime: "",
    endTime: "",
  },
  {
    day: "Thursday",
    isAvailable: false,
    startTime: "",
    endTime: "",
  },
  {
    day: "Friday",
    isAvailable: false,
    startTime: "",
    endTime: "",
  },
  {
    day: "Saturday",
    isAvailable: false,
    startTime: "",
    endTime: "",
  },
  {
    day: "Sunday",
    isAvailable: false,
    startTime: "",
    endTime: "",
  },
];

const useStyle = {
  selectStyle: {
    "&.MuiOutlinedInput-root .MuiSelect-outlined": {
      display: "flex",
      alignItems: "center",
      padding: "8px 12px",
    },
    "&.MuiOutlinedInput-root ": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #8692A6 `,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #8692A6 `,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #8692A6 `,
      },
    },
    "&.Mui-error ": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #d32f2f `,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #d32f2f `,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #d32f2f `,
      },
    },
  },
};

const WorkerShedule = () => {
  const navigate = useNavigate();
  const { workerId, type } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [scheduleDataState, setScheduleDataState] = useState(scheduleData);

  const handleSelectDay = (e, index) => {
    const tempData = [...scheduleDataState];
    tempData[index].isAvailable = e.target.checked;
    setScheduleDataState(tempData);
  };

  const handleChangeStartTime = (e, index) => {
    const tempData = [...scheduleDataState];
    tempData[index].startTime = e.target.value;
    tempData[index].endTime = "";
    setScheduleDataState(tempData);
  };

  const handleChangeEndTime = (e, index) => {
    const tempData = [...scheduleDataState];

    const start = moment(tempData[index].startTime, "HH:mm");
    const end = moment(e.target.value, "HH:mm");

    if (end.isSameOrBefore(start)) {
      handleOpenSnackBar(
        "error",
        t("sheduleEndTimeMustBeGreaterThanStartTime")
      );
      return;
    }

    tempData[index].endTime = e.target.value;
    setScheduleDataState(tempData);
  };

  const handleSaveSchedule = async () => {
    const finalData = scheduleDataState.filter(
      (item) => item.isAvailable && item.startTime && item.endTime
    );

    if (finalData.length === 0) {
      handleOpenSnackBar("error", t("pleaseSelectAtLeastOneDay"));
      return;
    }

    const handleError = scheduleDataState.some(
      (item) => item.isAvailable && (!item.startTime || !item.endTime)
    );
    if (handleError) {
      handleOpenSnackBar("error", t("pleaseFillAllSheduleFields"));
      return;
    }

    try {
      setIsLoading(true);
      const response = await updateWorkerAvailability(workerId, finalData);
      if (response?.data?.status === "success") {
        handleOpenSnackBar("success", response.data.message);
        navigate("/login", { state: { type: type } });
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const renderRightPart = () => {
    return (
      <Stack alignItems={"flex-end"}>
        <GlobalButton
          variant={"contained"}
          btnText={t("saveSchedule")}
          styleProps={{ fontWeight: 400, width: "auto" }}
          handleClickBtn={handleSaveSchedule}
        />
      </Stack>
    );
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <Box
        sx={{
          background: "linear-gradient(to bottom, #f7f9fc, #e8ecf1)",
          minHeight: "100vh",
          pt: 8,
          pb: 5,
        }}
      >
        {/* Header with Logo */}
        <Stack
          px={2}
          py={1}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          boxShadow="rgba(0, 0, 0, 0.15) 0px 1px 15px 0px"
          position="fixed"
          top={0}
          right={0}
          left={0}
          zIndex={1}
          bgcolor="white"
        >
          <img
            src={appLogo.eazidayLogoNew}
            alt="app-logo"
            width={40}
            style={{ height: "auto", transition: "transform 0.2s" }}
            onClick={() => navigate("/")}
          />

          <LanguageMenu />
        </Stack>

        <Container>
          <AppContainer
            primaryHeading={t("schedule")}
            secondaryHeading={t("viewSchedule")}
            headProps={renderRightPart()}
          >
            <Grid container>
              {scheduleDataState.map((item, index) => (
                <Grid item xs={12} md={6} lg={4} key={item.day}>
                  <Box
                    key={item.day}
                    border={"1px solid"}
                    borderColor={appcolors.primary}
                    borderRadius={"10px"}
                    p={2}
                    m={2}
                  >
                    <Stack
                      direction={"row"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Stack gap={1} direction={"row"} alignItems={"center"}>
                        <CustomSwitch
                          checked={item.isAvailable}
                          onChange={(e) => handleSelectDay(e, index)}
                        />
                        <Typography fontWeight={600}>{item.day}</Typography>
                      </Stack>
                    </Stack>
                    <Grid mt={1} container alignItems={"center"}>
                      <Grid item xs={12} md={5.5}>
                        <Typography variant="body2">
                          {t("sheduleStartTime")}
                        </Typography>
                        <FormControl fullWidth>
                          <Select
                            disabled={!item.isAvailable}
                            name={"sheduleStartTime"}
                            value={item.startTime}
                            onChange={(e) => handleChangeStartTime(e, index)}
                            sx={{
                              ...useStyle.selectStyle,
                            }}
                          >
                            <MenuItem value={""}>
                              {t("selectSheduleStartTime")}
                            </MenuItem>
                            {Array.from({ length: 24 }, (_, i) => i).map(
                              (val, _i) => {
                                const startTime = `${val
                                  .toString()
                                  .padStart(2, "0")}:00`;
                                return (
                                  <MenuItem key={_i} value={startTime}>
                                    {startTime}
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={1}>
                        <Typography textAlign={"center"} fontWeight={600}>
                          -
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={5.5}>
                        <Typography variant="body2">
                          {t("sheduleEndTime")}
                        </Typography>
                        <FormControl fullWidth>
                          <Select
                            name={"sheduleEndTime"}
                            disabled={!item.isAvailable || !item.startTime}
                            value={item.endTime}
                            onChange={(e) => handleChangeEndTime(e, index)}
                            sx={{
                              ...useStyle.selectStyle,
                            }}
                          >
                            <MenuItem value={""}>
                              {t("selectSheduleEndTime")}
                            </MenuItem>
                            {Array.from({ length: 24 }, (_, i) => i).map(
                              (val, _i) => {
                                const endTime = `${val
                                  .toString()
                                  .padStart(2, "0")}:00`;
                                return (
                                  <MenuItem key={_i} value={endTime}>
                                    {endTime}
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </AppContainer>
        </Container>
      </Box>
    </>
  );
};

export default WorkerShedule;
